import React from 'react'

const createLabel = ({isOpenDetailSearchCondition}) => (
  (isOpenDetailSearchCondition) ? TRUCKERS.LANG.BUTTON.CLOSE_DETAILS : TRUCKERS.LANG.BUTTON.ADD_DETAILS
)
const createClassName = ({isOpenDetailSearchCondition}) => (
  (isOpenDetailSearchCondition)? 'btnAdd is-active' : 'btnAdd'
)

const ExpandButton = (props) => {
  const { handleExpandClicked } = props
  return <li className='searchArea__button__add'>
    <a
      href='#'
      className={createClassName(props)}
      id='js-searchMoreButton'
      onClick={handleExpandClicked}
    >
      {createLabel(props)}
    </a>
  </li>
}
export default ExpandButton
